import { AttributeInput } from "@idw-types/data";
import { VerifiedAttribute } from "@idw-types/data/verified-attribute";

export enum VerificationFormActionTypes {
    // CLEAR_SUBMIT_VALUES = "CLEAR_SUBMIT_VALUES",
    SET_VERIFICATION_FORM = "SET_VERIFICATION_FORM",
	ADD_NEW_ATTRIBUTE_VALUE = "ADD_NEW_ATTRIBUTE_VALUE",
    SET_IS_ASYNC_COMPLETE = "SET_IS_ASYNC_COMPLETE",
    SET_IS_OOB_COMPLETE = "SET_IS_OOB_COMPLETE",
	CHECK_OOB_COMPLETE = "CHECK_OOB_COMPLETE",
	CLEAR_ATTRIBUTE_SUBMIT_VALUES = "CLEAR_ATTRIBUTE_SUBMIT_VALUES",
	DESERIALIZE_ATTRIBUTES = "DESERIALIZE_ATTRIBUTES",
	DISABLE_ASYNC_BUTTON = "DISABLE_ASYNC_BUTTON",
	DISABLE_SUBMIT_BUTTON = "DISABLE_SUBMIT_BUTTON",
	FOCUS_ON_NEXT_ATTRIBUTE = "FOCUS_ON_NEXT_ATTRIBUTE",
	SET_VERIFICATION_PROCESSED = "SET_VERIFICATION_PROCESSED",
	RESET_ATTRIBUTE_STATE = "RESET_ATTRIBUTE_STATE",
	SET_ASSERTION_ERROR_MESSAGES = "SET_ASSERTION_ERROR_MESSAGES",
	SET_ASYNC_BUTTON_TEXT = "SET_ASYNC_BUTTON_TEXT",
	SET_ASYNC_COMPLETED = "SET_ASYNC_COMPLETED",
	SET_ASYNC_INTERVAL = "SET_ASYNC_INTERVAL",
	SET_ASYNC_MODAL_MESSAGE = "SET_ASYNC_MODAL_MESSAGE",
	SET_ASYNC_TIMEOUT_ID = "SET_ASYNC_TIMEOUT_ID",
	SET_ATTRIBUTE_IN_FOCUS = "SET_ATTRIBUTE_IN_FOCUS",
	SET_ATTRIBUTE_PICKER_VALUE = "SET_ATTRIBUTE_PICKER_VALUE",
	SET_ATTRIBUTE_SUBMIT_VALUE = "SET_ATTRIBUTE_SUBMIT_VALUE",
	SET_DCUI_CANCEL_COUNT = "SET_DCUI_CANCEL_COUNT",
	SET_DCUI_CANCEL_MAX = "SET_DCUI_CANCEL_MAX",
	SET_RETRY_VERIFICATION = "SET_RETRY_VERIFICATION",
	SET_SHOW_ASYNC_BUTTON = "SET_SHOW_ASYNC_BUTTON",
	SET_SHOW_ASYNC_MODAL = "SET_SHOW_ASYNC_MODAL",
	SET_SHOW_ASYNC_MODAL_CANCEL_BUTTON = "SET_SHOW_ASYNC_MODAL_CANCEL_BUTTON",
	UPDATE_ATTEMPT = "UPDATE_ATTEMPT",
	UPDATE_ATTRIBUTE_ASYNC_STATUS = "UPDATE_ATTRIBUTE_ASYNC_STATUS",
	UPDATE_ATTRIBUTE_PROPERTY = "UPDATE_ATTRIBUTE_PROPERTY",
	UPDATE_ATTRIBUTE_VERIFIED_STATUSES = "UPDATE_ATTRIBUTE_VERIFIED_STATUSES",
	SET_ASYNC_METHOD = "SET_ASYNC_METHOD",
    SET_ATTRIBUTE_FORM_STATE_IS_READ_ONLY = "SET_ATTRIBUTE_FORM_STATE_IS_READ_ONLY",
    SET_IS_DCUI_PROCESS_COMPLETED = "SET_IS_DCUI_PROCESS_COMPLETED",
    SET_EXPLICIT_CONSENT_CHECKED = "SET_EXPLICIT_CONSENT_CHECKED"
}

type SetVerificationFormAction = {
    type: VerificationFormActionTypes.SET_VERIFICATION_FORM;
    payload: { attributeInputList: Array<AttributeInput> };
};

export const setVerificationForm = (attributeInputList: Array<AttributeInput>): SetVerificationFormAction => ({
    type: VerificationFormActionTypes.SET_VERIFICATION_FORM,
    payload: {
        attributeInputList
    }
});

type AddNewAttributeValueAction = {
    type: VerificationFormActionTypes.ADD_NEW_ATTRIBUTE_VALUE;
    payload: { verifiedAttribute: AttributeInput; inputData: any; }
};

export const addNewAttributeValue = (verifiedAttribute: AttributeInput, inputData: any): AddNewAttributeValueAction => ({
    type: VerificationFormActionTypes.ADD_NEW_ATTRIBUTE_VALUE,
    payload: { verifiedAttribute, inputData }
});

type SetAttributeSubmitValueAction = {
    type: VerificationFormActionTypes.SET_ATTRIBUTE_SUBMIT_VALUE;
    payload: { attribute: AttributeInput; inputData: any; };
};

export const setAttributeSubmitValue = (attribute: AttributeInput, inputData: any): SetAttributeSubmitValueAction => ({
    type: VerificationFormActionTypes.SET_ATTRIBUTE_SUBMIT_VALUE,
    payload: { attribute, inputData }
});

type SetAttributePickerValueAction = {
    type: VerificationFormActionTypes.SET_ATTRIBUTE_PICKER_VALUE;
    payload: { attribute: AttributeInput; pickerData: any; };
};

export const setAttributePickerValue = (attribute: AttributeInput, pickerData: any): SetAttributePickerValueAction => ({
    type: VerificationFormActionTypes.SET_ATTRIBUTE_PICKER_VALUE,
    payload: { attribute, pickerData }
});

type UpdateAttributeVerifiedStatusesAction = {
    type: VerificationFormActionTypes.UPDATE_ATTRIBUTE_VERIFIED_STATUSES;
    payload: { verifiedAttributes: Array<VerifiedAttribute>; attempt: number; allowDCUIretry: boolean; };
};

export const updateAttributeVerifiedStatuses = (verifiedAttributes: Array<VerifiedAttribute>, attempt: number, allowDCUIretry: boolean): UpdateAttributeVerifiedStatusesAction => ({
    type: VerificationFormActionTypes.UPDATE_ATTRIBUTE_VERIFIED_STATUSES,
    payload: { verifiedAttributes, attempt, allowDCUIretry }
});

type UpdateAttributeAsyncStatusAction = {
    type: VerificationFormActionTypes.UPDATE_ATTRIBUTE_ASYNC_STATUS;
    payload: { attribute: AttributeInput; };
};

export const updateAttributeAsyncStatus = (attribute: AttributeInput): UpdateAttributeAsyncStatusAction => ({
    type: VerificationFormActionTypes.UPDATE_ATTRIBUTE_ASYNC_STATUS,
    payload: { attribute }
});

type ClearAttributeSubmitValuesAction = {
    type: VerificationFormActionTypes.CLEAR_ATTRIBUTE_SUBMIT_VALUES;
    payload: { attribute: AttributeInput };
};

export const clearAttributeSubmitValues = (attribute: AttributeInput): ClearAttributeSubmitValuesAction => ({
    type: VerificationFormActionTypes.CLEAR_ATTRIBUTE_SUBMIT_VALUES,
    payload: { attribute }
});


type SetIsDcuiProcessCompletedAction = {
    type: VerificationFormActionTypes.SET_IS_DCUI_PROCESS_COMPLETED;
    payload: { isDcuiProcessCompleted: boolean }
};

export const setIsDcuiProcessCompleted = (isDcuiProcessCompleted: boolean): SetIsDcuiProcessCompletedAction => ({
    type: VerificationFormActionTypes.SET_IS_DCUI_PROCESS_COMPLETED,
    payload: { isDcuiProcessCompleted }
});

type SetIsOOBCompleteAction = {
    type: VerificationFormActionTypes.SET_IS_OOB_COMPLETE;
    payload: { isOOBComplete: boolean }
};

export const setIsOOBComplete = (isOOBComplete: boolean): SetIsOOBCompleteAction => ({
    type: VerificationFormActionTypes.SET_IS_OOB_COMPLETE,
    payload: { isOOBComplete }
});

type CheckOOBCompleteAction = {
    type: VerificationFormActionTypes.CHECK_OOB_COMPLETE;
};

export const checkOOBComplete = (): CheckOOBCompleteAction => ({
    type: VerificationFormActionTypes.CHECK_OOB_COMPLETE
});

type SetIsAsyncCompleteAction = {
    type: VerificationFormActionTypes.SET_IS_ASYNC_COMPLETE;
    payload: { isAsyncComplete: boolean }
};

export const setIsAsyncComplete = (isAsyncComplete: boolean): SetIsAsyncCompleteAction => ({
    type: VerificationFormActionTypes.SET_IS_ASYNC_COMPLETE,
    payload: { isAsyncComplete }
});

type SetAsyncCompletedAction = {
    type: VerificationFormActionTypes.SET_ASYNC_COMPLETED;
    payload: { isCompleted: boolean; };
};

export const setAsyncCompleted = (isCompleted: boolean): SetAsyncCompletedAction => ({
    type: VerificationFormActionTypes.SET_ASYNC_COMPLETED,
    payload: { isCompleted }
});

type SetShowAsyncButtonAction = {
    type: VerificationFormActionTypes.SET_SHOW_ASYNC_BUTTON;
    payload: { showAsyncButton: boolean; };
};

export const setShowAsyncButton = (showAsyncButton: boolean): SetShowAsyncButtonAction => ({
    type: VerificationFormActionTypes.SET_SHOW_ASYNC_BUTTON,
    payload: { showAsyncButton }
});

type SetAssertionErrorMessagesAction = {
    type: VerificationFormActionTypes.SET_ASSERTION_ERROR_MESSAGES;
    payload: { messages: Array<string> };
};

export const setAssertionErrorMessages = (messages: Array<string>): SetAssertionErrorMessagesAction => ({
    type: VerificationFormActionTypes.SET_ASSERTION_ERROR_MESSAGES,
    payload: { messages }
});

type DisableAsyncButtonAction = {
    type: VerificationFormActionTypes.DISABLE_ASYNC_BUTTON;
    payload: { disableAsyncButton: boolean; };
};

export const disableAsyncButton = (disableAsyncButton: boolean): DisableAsyncButtonAction => ({
    type: VerificationFormActionTypes.DISABLE_ASYNC_BUTTON,
    payload: { disableAsyncButton }
});

type DisableSubmitButtonAction = {
    type: VerificationFormActionTypes.DISABLE_SUBMIT_BUTTON;
    payload: { disableSubmitButton: boolean; };
};

export const disableSubmitButton = (disableSubmitButton: boolean): DisableSubmitButtonAction => ({
    type: VerificationFormActionTypes.DISABLE_SUBMIT_BUTTON,
    payload: { disableSubmitButton }
});

type SetAsyncButtonTextAction = {
    type: VerificationFormActionTypes.SET_ASYNC_BUTTON_TEXT;
    payload: { asyncButtonText: string; };
};

export const setAsyncButtonText = (asyncButtonText: string): SetAsyncButtonTextAction => ({
    type: VerificationFormActionTypes.SET_ASYNC_BUTTON_TEXT,
    payload: { asyncButtonText }
});

type SetShowAsyncModalAction = {
    type: VerificationFormActionTypes.SET_SHOW_ASYNC_MODAL;
    payload: { show: boolean; };
};

export const setShowAsyncModal = (show: boolean): SetShowAsyncModalAction => ({
    type: VerificationFormActionTypes.SET_SHOW_ASYNC_MODAL,
    payload: { show }
});

type SetShowAsyncModalCancelButtonAction = {
    type: VerificationFormActionTypes.SET_SHOW_ASYNC_MODAL_CANCEL_BUTTON;
    payload: { show: boolean; };
};

export const setShowAsyncModalCancelButton = (show: boolean): SetShowAsyncModalCancelButtonAction => ({
    type: VerificationFormActionTypes.SET_SHOW_ASYNC_MODAL_CANCEL_BUTTON,
    payload: { show }
});

type SetAsyncModalMessage = {
    type: VerificationFormActionTypes.SET_ASYNC_MODAL_MESSAGE;
    payload: { message: string; };
};

export const setAsyncModalMessage = (message: string): SetAsyncModalMessage => ({
    type: VerificationFormActionTypes.SET_ASYNC_MODAL_MESSAGE,
    payload: { message }
});

type SetAsyncTimeoutIdAction = {
    type: VerificationFormActionTypes.SET_ASYNC_TIMEOUT_ID;
    payload: { timeoutId: NodeJS.Timeout; };
};

export const setAsyncTimeoutId = (timeoutId: NodeJS.Timeout): SetAsyncTimeoutIdAction => ({
    type: VerificationFormActionTypes.SET_ASYNC_TIMEOUT_ID,
    payload: { timeoutId }
});

type SetDCUICancelCountAction = {
    type: VerificationFormActionTypes.SET_DCUI_CANCEL_COUNT;
    payload: { count: number };
};

export const setDCUICancelCount = (count: number): SetDCUICancelCountAction => ({
    type: VerificationFormActionTypes.SET_DCUI_CANCEL_COUNT,
    payload: { count }
});

type SetDCUICancelMaxAction = {
    type: VerificationFormActionTypes.SET_DCUI_CANCEL_MAX;
    payload: { max: number; };
};

export const setDCUICancelMax = (max: number): SetDCUICancelMaxAction => ({
    type: VerificationFormActionTypes.SET_DCUI_CANCEL_MAX,
    payload: { max }
});

type SetRetryVerificationAction = {
    type: VerificationFormActionTypes.SET_RETRY_VERIFICATION;
    payload: { retryVerification: boolean; };
};

export const setRetryVerification = (retryVerification: boolean): SetRetryVerificationAction => ({
    type: VerificationFormActionTypes.SET_RETRY_VERIFICATION,
    payload: { retryVerification }
});

type UpdateAttemptAction = {
    type: VerificationFormActionTypes.UPDATE_ATTEMPT;
    payload: { attempt: number; };
};

export const updateAttempt = (attempt: number): UpdateAttemptAction => ({
    type: VerificationFormActionTypes.UPDATE_ATTEMPT,
    payload: { attempt }
});

type SetVerificationProcessedAction = {
    type: VerificationFormActionTypes.SET_VERIFICATION_PROCESSED;
    payload: { processed: boolean; };
};

export const setVerificationProcessed = (processed: boolean): SetVerificationProcessedAction => ({
    type: VerificationFormActionTypes.SET_VERIFICATION_PROCESSED,
    payload: { processed }
});

type SetAttributeInFocusAction = {
    type: VerificationFormActionTypes.SET_ATTRIBUTE_IN_FOCUS;
    payload: { attributeId: number; }
};

export const setAttributeInFocus = (attributeId: number): SetAttributeInFocusAction => ({
    type: VerificationFormActionTypes.SET_ATTRIBUTE_IN_FOCUS,
    payload: { attributeId }
});

type FocusOnNextAttributeAction = {
    type: VerificationFormActionTypes.FOCUS_ON_NEXT_ATTRIBUTE;
};

export const focusOnNextAttribute = (): FocusOnNextAttributeAction => ({
    type: VerificationFormActionTypes.FOCUS_ON_NEXT_ATTRIBUTE
});

type SetAsyncMethodAction = {
    type: VerificationFormActionTypes.SET_ASYNC_METHOD;
    payload: { method: string; };
};

export const setAsyncMethod = (method: string): SetAsyncMethodAction => ({
    type: VerificationFormActionTypes.SET_ASYNC_METHOD,
    payload: { method }
});

type SetAttributeFormStateIsReadOnlyAction = {
    type: VerificationFormActionTypes.SET_ATTRIBUTE_FORM_STATE_IS_READ_ONLY,
    payload: { attributeId: number; isReadOnly: boolean };
};

export const setAttributeFormStateIsReadOnly = (attributeId: number, isReadOnly: boolean): SetAttributeFormStateIsReadOnlyAction => ({
    type: VerificationFormActionTypes.SET_ATTRIBUTE_FORM_STATE_IS_READ_ONLY,
    payload: { attributeId, isReadOnly }
});

type SetExplicitConsentCheckedAction = {
    type: VerificationFormActionTypes.SET_EXPLICIT_CONSENT_CHECKED;
    payload: { checked: boolean; };
};

export const setExplicitConsentChecked = (checked: boolean): SetExplicitConsentCheckedAction => ({
    type: VerificationFormActionTypes.SET_EXPLICIT_CONSENT_CHECKED,
    payload: { checked }
});

export type VerificationFormActions =
    SetVerificationFormAction |
    AddNewAttributeValueAction |
    SetAttributeSubmitValueAction |
    SetAttributePickerValueAction |
    UpdateAttributeVerifiedStatusesAction |
    UpdateAttributeAsyncStatusAction |
    ClearAttributeSubmitValuesAction |
    SetIsOOBCompleteAction |
    CheckOOBCompleteAction |
    SetIsAsyncCompleteAction |
    SetAsyncCompletedAction |
    SetIsDcuiProcessCompletedAction |
    SetShowAsyncButtonAction |
    SetAssertionErrorMessagesAction |
    DisableAsyncButtonAction |
    DisableSubmitButtonAction |
    SetAsyncButtonTextAction |
    SetShowAsyncModalAction |
    SetShowAsyncModalCancelButtonAction |
    SetAsyncModalMessage |
    SetAsyncTimeoutIdAction |
    SetDCUICancelCountAction |
    SetDCUICancelMaxAction |
    SetRetryVerificationAction |
    UpdateAttemptAction |
    SetVerificationProcessedAction |
    SetAttributeInFocusAction |
    FocusOnNextAttributeAction |
    SetAsyncMethodAction |
    SetAttributeFormStateIsReadOnlyAction |
    SetExplicitConsentCheckedAction